import {
  AbstractControl, ValidatorFn,
} from '@angular/forms';

import { isValid, isGTIN } from 'gtin';


export const gtinValidation = function (): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} => {
    const err = {'GTIN': 'GTIN is invalid'};
    if (!control.value) {
      return null;
    }
    try {
      const isValidGtin = isGTIN(control.value) && isValid(control.value);
      return isValidGtin ? null : err;
    } catch (e) {
      return err;
    }
  };
};
